import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { TableroTurnosService } from 'src/app/services/tableroTurnos/tablero-turnos.service';
import { TurnoUACModel } from 'src/app/models/turnoUAC.model';
import { AssetsService } from 'src/app/shared/services/assets.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { GlobalService } from 'src/app/shared/global.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Howl, Howler } from 'howler';

@Component({
    selector: 'app-tablero-turnos',
    templateUrl: './tablero-turnos.component.html',
    styleUrls: ['./tablero-turnos.component.scss'],
    providers: [UrlService, TableroTurnosService]
})
export class TableroTurnosComponent implements OnInit, OnDestroy {

    private sound = new Howl({
        src: ['assets/alertTurno.wav']
    });
    turnoActual: TurnoUACModel;
    turnosLlamados: TurnoUACModel[];
    fechaActual: string;
    iconDemo: string;
    sedeActual: string;
    mensajeFooter: string;
    horaActual: string;
    velocidadDesplazamiento: string;
    parametros: any;
    duracionMensaje: string;
    idSedeActual: string;
    public subscription: Subscription[] = [];

    constructor(
        private global: GlobalService,
        private tableroTurnosService: TableroTurnosService,
        private util: UtilService,
        private urlService: UrlService, private alertService: AlertService, private route: ActivatedRoute) {


        this.iconDemo = AssetsService.URL_ICONO_DEMO_JPG;
        this.sedeActual = 'PRINCIPAL';
        this.idSedeActual = 'PRINC';
        this.mensajeFooter = '';
        this.turnoActual = new TurnoUACModel();
        this.parametros = [];
        this.duracionMensaje = '50';
        this.turnosLlamados = [];
        this.initHoraActual();

    }

    ngOnInit() {
        this.sound.play();
        this.obenerFechaActual();
        this.idSedeActual = this.route.snapshot.paramMap.get('sede');
        this.obtenerParametrosIniciales(0);

        //Turno inicial no válido, solo por estética
        let turnoVacio: TurnoUACModel = new TurnoUACModel();
        turnoVacio.letraTurno = '-';
        turnoVacio.numeroTurno = '-';
        turnoVacio.numeroVentanilla = '-';
        turnoVacio.nombreCompleto = '-';
        this.turnoActual = turnoVacio;
        this.turnosLlamados.push(turnoVacio);

    }

    obtenerParametrosIniciales(intento) {
        if (intento < 3) {
            if (this.urlService.API_WEBSOCKET_TURNOS) {
                this.cargar();
            } else {
                setTimeout(() => {
                    this.urlService.refrescar();
                    this.obtenerParametrosIniciales(intento++);
                }, 200);
            }
        } else {
            this.cathException('Error Consultando parametros requeridos por la pantalla');
        }
    }

    cargar() {
        this.obtenerParametros();
        this.tableroTurnosService.setSedePeticion(this.idSedeActual);
        this.tableroTurnosService.obtenerTurnosWebSocket();
        const subs = this.tableroTurnosService.turnos.subscribe(
            turno => {
                this.turnoActual = turno;
                if (this.turnosLlamados.length == 5) {
                    this.turnosLlamados.pop();
                }

                let positionFound: number = null;
                for (let index = 0; index < this.turnosLlamados.length; index++) {
                    const element = this.turnosLlamados[index];
                    if (element.idTurno === turno.idTurno) {
                        positionFound = index;
                    }
                }

                if (positionFound != null) {
                    this.turnosLlamados.splice(positionFound);
                }

                this.turnosLlamados.unshift(turno);
                this.sound.play();
            }
        );
        this.subscription.push(subs);
    }


    /**
     * obtiene la fecha Actual en el formato que se debe mostrar
     * @author fromero
     */
    obenerFechaActual() {
        this.fechaActual = this.util.obtnerFechaLetras(new Date());
    }

    /**
     * Construye el reloj de la pantalla
     * @author fromero
     */
    initHoraActual() {
        setInterval(() => {
            this.horaActual = this.util.initHoraActual();
        }, 1000);
    }


    /**
     * obtiene los paràmetros de la BD
     * @author fromero
     */
    obtenerParametros() {

        const serviceProvider = 'ObtenerParametros';
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
        this.global.getPublico(url).subscribe(
            data => {
                this.parametros = data;
                this.setParametros();
            }, err => {
                this.cathException('Error Consultando parametros requeridos por la pantalla');
            }
        );
    }


    /**
     * Mapea los parámetros necesarios para operación de la pantalla
     * @author fromero
     */
    setParametros() {

        this.parametros.forEach(element => {
            if (element.nombre == ConstantesService.MENSAJE_PANTALLA_TURNOS) {
                this.mensajeFooter = element.valor;
            }
            if (element.nombre == ConstantesService.TIEMPO_MENSAJE_PANTALLA_TURNOS) {
                this.duracionMensaje = element.valor;
            }
        });

    }

    /**
     * Genera alertas de error en caso de fallos de servicios
     * @param err 
     * @author fromero
     */
    cathException(err) {

        this.alertService.generateAlertError(err, '');
    }

    /**
     * destruye las subscripciones del componente
     * @author fromero
     */
    @HostListener('window:beforeunload')
    ngOnDestroy() {
        this.tableroTurnosService.destroyWs();
        this.subscription.forEach(subs => {
            subs.unsubscribe();
        });
    }
}
